<script>
export default {
  name: "TranslateForm",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
    }
  }
}
</script>

<template>
  <el-form label-width="auto">
    <el-form-item :label="$t('lang.支持语言')">
      <span v-for="(item, index) in data.supportLangList" :key="index">{{ item }}</span>
    </el-form-item>

    <el-form-item :label="$t('lang.主语言')">
      <span>{{data.lang}}</span>
    </el-form-item>

    <el-form-item :label="$t('lang.食谱类型')">
      <span>{{ data.type }}</span>
    </el-form-item>
    <el-form-item :label="$t('lang.食谱名称')">
      <el-input v-model="data.name" :disabled="disabled" :placeholder="$t('lang.食谱名称')" />
    </el-form-item>

    <el-form-item :label="$t('lang.所属分类')">
<!--      <span>{{ data.category }}</span>-->
      <el-input v-model="data.category" :disabled="disabled" :placeholder="$t('lang.食谱分类')" />
    </el-form-item>
    <el-form-item :label="$t('lang.份量')">
      <el-input :value="data.portionSize" disabled />
    </el-form-item>

    <el-form-item :label="$t('lang.食材')">
      <div class="list">
        <div v-for="(item, index) in data.foods" :key="index" class="list-item">
          <div style="flex: 1; display: flex; column-gap: 8px;">
            <el-input style="width: 50%" :value="item.amount" disabled />
            <div style="flex: 1; text-align: center">{{item.unit}}</div>
          </div>
          <el-input style="flex: 1" v-model="item.value" :disabled="disabled" />
        </div>
      </div>
    </el-form-item>

    <el-form-item :label="$t('lang.食材描述')">
      <el-input v-model="data.foodDescription" :disabled="disabled" type="textarea" :rows="4" />
    </el-form-item>

    <el-form-item :label="$t('lang.做法介绍')">
      <el-input v-model="data.introduction" :disabled="disabled" type="textarea" :rows="4" />
    </el-form-item>

    <el-form-item :label="$t('lang.厨师建议')">
      <el-input v-model="data.chefRec" :disabled="disabled" type="textarea" :rows="4" />
    </el-form-item>

    <el-form-item :label="$t('lang.烹饪步骤')">
      <div v-for="(item, index) in data.cookingStepList" :key="index">
        <span>{{index + 1}}、{{ item.workModeName }}</span>
        <el-input v-model="item.value" :disabled="disabled" />
      </div>
    </el-form-item>

    <el-form-item :label="$t('lang.准备时间')">
      <span>{{ data.prepareTime }}</span>
    </el-form-item>

    <el-form-item :label="$t('lang.制作时间')">
      <span>{{data.makeTime}}</span>
    </el-form-item>

    <el-form-item :label="$t('lang.休息时间')">
      <span>{{ data.restTime }}</span>
    </el-form-item>

    <el-form-item :label="$t('lang.营养成分')">
      <div class="list">
        <div v-for="(item, index) in data.nutritionList" :key="index" class="list-item">
          <el-input :value="item.amount" disabled />
          <span>{{item.unit}}</span>
          <el-input v-model="item.value" :disabled="disabled" />
        </div>
      </div>
    </el-form-item>

    <el-form-item :label="$t('lang.难易水平')">
      <span>{{ data.difficultyLevel }}</span>
    </el-form-item>

    <el-form-item :label="$t('lang.选择标签')">
      <span>{{ data.tags }}</span>
    </el-form-item>

    <el-form-item :label="$t('lang.兼容型号')">
      <span>{{ data.products }}</span>
    </el-form-item>

    <!-- 底部  -->
    <slot name="bottom"></slot>
  </el-form>
</template>

<style scoped>
.list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.list-item {
  display: flex;
  align-items: center;
  column-gap: 8px;
}

.list-item span {
  flex-shrink: 0;
}
</style>
